/**
 * Inventory settings API client (BFF: `/api/v1/store/settings/inventory`).
 *
 * Stock tracking, reservation and availability policy (→ web-inventory-service).
 */
import { apiClient } from '@/shared/api';
import type { InventorySettings, UpdateInventorySettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/inventory';

export const getInventorySettings = async (): Promise<InventorySettings> =>
  (await apiClient.get<InventorySettings>(BASE)).data;

export const updateInventorySettings = async (
  body: UpdateInventorySettingsRequest,
): Promise<InventorySettings> => (await apiClient.put<InventorySettings>(BASE, body)).data;
